
import { mapState } from 'vuex'
import Vue from 'vue'
import gallery from '~/mixins.js/gallery'
import diagram from '~/mixins.js/diagram'

if (process.client && window) {
  require('lightgallery.js/dist/css/lightgallery.min.css')
  const lightgallery = require('lightgallery.js')
  Vue.use(lightgallery)
}

export default {
  mixins: [gallery, diagram],
  props: {
    diagram: {
      required: true,
      type: Object
    },
    images: {
      required: true,
      type: Array
    },
    totalCount: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      slidesExpanded: false,
      slidesLimit: 6,
      lazyImages: []
    }
  },
  computed: {
    ...mapState('diagram', ['activeSlideIndex']),
    allImages () {
      return [this.diagram.image, ...this.images, ...this.lazyImages]
    },
    displayedSlides () {
      if (!this.slidesExpanded) {
        return this.allImages.slice(0, this.slidesLimit)
      } else {
        return this.allImages
      }
    },
    hasMoreImages () {
      return this.totalCount > this.slidesLimit
    }
  },
  methods: {
    async toggleSlides () {
      if (this.totalCount > this.images.length + this.lazyImages.length) {
        const lazy = await this.fetchSlides(2, 5)
        this.lazyImages = lazy
      }
      this.slidesExpanded = !this.slidesExpanded
    }
  }
}
